import { useEffect, useState } from 'react'

type UseToleranceGroupInputProps = {
  dbValue: number | null
  onChange: (value: number | null) => void
}

export const useToleranceGroupInput = ({ dbValue, onChange }: UseToleranceGroupInputProps) => {
  const [value, setLocalValue] = useState<string>(dbValue?.toString() ?? '')

  useEffect(() => {
    setLocalValue(dbValue?.toString() ?? '')
  }, [dbValue])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value
    setLocalValue(raw)
    const numValue = raw === '' ? null : Number(raw)
    if (numValue === null || (Number.isFinite(numValue) && numValue >= 0)) {
      onChange(numValue)
    }
  }

  return { value, handleChange }
}
